module.exports = __webpack_public_path__ + "assets/4.6159c0ad.jpg";